<template>
    <el-dialog :visible.sync="boxVisible"  v-if="boxVisible"  class="myDialog NoticeBox"
        :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" :align-center="true">
        <div class="myDialog-body">
            <i class="el-icon-circle-close myDialog-close" @click="close"></i>
            <div class="myDialog-title">{{$t("common.notice")}}</div>
            <div class="myDialog-content">
                <div class="notice-content">
                    <p class="header">{{ $t('common.noticeContent1') }}</p>
                    <p class="content">{{ $t('common.noticeContent2') }}</p>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {getLanguage} from '@/assets/js/config';
import { getNotice,setNotice } from '@/assets/js/user';
export default {
    name:"NoticeBox",
    data() {
        return {
            boxVisible:false,
            noticeList:[],
        };
    },
    created() {
        
    },
    methods:{
        show() {
            if(getNotice()){
                return;
            }
            this.boxVisible = true;
        },
        close() {
            setNotice(true);
            this.boxVisible = false;
        }
    }
}
</script>
<style lang='less'>
.NoticeBox {
    .notice-content{
        color: #9ABCDF;
        text-align:left;
        max-height:400px;
        overflow-y:auto;
        p.header{
            margin:0px;
            font-size: 14px;
            line-height: 20px;
            word-break: auto-phrase;
        }
        p.content{
            margin: 12px 0px 0px 0px;
            font-size: 14px;
            line-height: 20px;
            word-break: auto-phrase;
        }
    }
}
</style>